export const NotificationConfig = {
  all: '/notification/findUserNotifications?pageNum={:pageNum}&pageSize={:pageSize}',
  create: '/notification/createUserNotification',
  deleteAll: '/notification/deleteUserNotifications'
};
